import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography, Link } from '@mui/material';

const LoadingScreen = ({ status }) => {
  const navigate = useNavigate();

  // Effekt zur Weiterleitung bei erfolgreichem Laden
  useEffect(() => {
    if (status === 'success') {
      const timeout = setTimeout(() => {
        navigate('/pages/configurator'); // Weiterleitung nach 3 Sekunden
      }, 3000);

      return () => clearTimeout(timeout); // Timeout aufräumen
    }
  }, [status, navigate]);

  // Zeilenumbruch nach jedem Satzzeichen (außer bei E-Mail-Adressen)
  const formatMessage = (message) => {
    // Teile den Text auf, berücksichtige dabei keine Zeilenumbrüche bei E-Mails
    const emailRegex = /info@schullogbuch24\.de/;
    const parts = message.split(emailRegex);

    return (
      <>
        {parts[0]
          .split(/(?<=[.!?])/)
          .map((line, index) => (
            <Typography
              key={index}
              sx={{
                color: status === 'success' ? '#9fc154' : status === 'error' ? '#f8333f' : 'inherit',
              }}
              variant="h6"
              gutterBottom
            >
              {line.trim()}
            </Typography>
          ))}
        {message.includes('info@schullogbuch24.de') && (
          <Typography
            sx={{
              color: status === 'success' ? 'green' : status === 'error' ? 'red' : 'inherit',
            }}
            variant="h6"
            gutterBottom
          >
            <Link href="mailto:info@schullogbuch24.de" color="inherit">
              info@schullogbuch24.de
            </Link>
          </Typography>
        )}
      </>
    );
  };

  let message = 'Bitte haben Sie einen Moment Geduld, während wir Ihren Druckauftrag prüfen.';
  let videoSrc = null; // Videoquelle basierend auf Status
  if (status === 'success') {
    message = 'Vielen Dank. Wir werden Ihren Druckauftrag in Kürze bearbeiten. Sie werden nun automatisch weitergeleitet.';
    videoSrc = '/uploads/videos/success.webm'; // Pfad zur Erfolgs-Animation
  } else if (status === 'error') {
    message = 'Es tut uns leid. Es ist leider etwas schief gelaufen. Bitte versuchen Sie es erneut oder wenden Sie sich an info@schullogbuch24.de.';
    videoSrc = '/uploads/videos/failure.webm'; // Pfad zur Fehler-Animation
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '60vh',
        maxWidth: '800px',
        width: '100%',
        margin: '10vh auto',
        textAlign: 'center',
        backgroundColor: '#f9f9f9',
        border: '1px solid rgba(0, 0, 0, 0.2)',
        borderRadius: '8px',
        padding: 2,
      }}
    >
      {status === 'loading' && <CircularProgress size={60} />}
      {videoSrc && (
        <video
          src={videoSrc}
          autoPlay
          muted
          style={{
            width: '150px',
            height: '150px',
            marginBottom: '20px',
          }}
        />
      )}
      {formatMessage(message)}
    </Box>
  );
};

export default LoadingScreen;